/**
 * 확인 요청 글의 **상태 판정** — 목록과 글 보기가 **같은 값**을 보게 하는 한 곳 (2026-09-16 · R1).
 *
 * ★★★ **왜 함수로 뺐나.** 같은 판정을 목록 표·고정 글 구획·글 보기 머리·확인 띠 네 곳에서 한다.
 *     각자 `requiresConfirm && !myConfirmedAt` 를 다시 쓰면 **한 곳만 고쳐지고 갈라진다** —
 *     목록에는 「확인 필요」인데 글을 열면 「확인함」인 상태가 그것이다.
 *
 * ★★ **상태는 셋이고, 그중 하나는 «아무것도 안 그림»이다**(2026-09-16 관제 지시).
 *     확인 요청이 없는 글에 **회색 배지라도 붙이지 않는다** — 시안의 그 행은 `—` 다.
 *     `'none'` 을 받은 쪽은 **아무 표식도 만들지 않는다**(「해당 없음」 배지를 만들지 말 것).
 *
 * ★ **숫자는 여기서 다루지 않는다.** 목록에 분모(`targetCount`)를 만들지 않기로 했고
 *   (2026-09-16 사용자 결정 ③ · 차이표 §0.25), 목록 배지는 **숫자 없이** 상태만 말한다.
 *   확인 수를 보여 주는 곳은 글 보기의 확인 현황이고 그건 따로 그린다.
 *
 * ★ 옛 서버는 `requiresConfirm` 자체를 안 준다 → `undefined` → `'none'` → 종전과 같은 화면이다.
 */

export type ConfirmState = 'none' | 'required' | 'confirmed';

/** 확인 상태를 정하는 데 필요한 칸만. 목록 항목과 상세가 **둘 다** 이 모양을 만족한다. */
export interface ConfirmSource {
  requiresConfirm?: boolean;
  /** 내가 확인한 시각. 확인 안 했으면 `null`, 서버가 안 주면 `undefined`. */
  myConfirmedAt?: string | null;
}

/**
 * ★ `myConfirmedAt` 이 **`undefined`** 인 경우를 「확인함」으로 읽지 않는다 —
 *   서버가 그 칸을 안 실어 보낸 것(옛 서버 · 확인 맥락이 없는 응답)이지 확인한 것이 아니다.
 *   「모른다」를 「했다」로 바꾸지 않는다.
 */
export function confirmStateOf(post: ConfirmSource | null | undefined): ConfirmState {
  if (!post?.requiresConfirm) return 'none';
  return post.myConfirmedAt ? 'confirmed' : 'required';
}

/** 내가 아직 확인하지 않은 «확인 요청» 글인가 — 「내 차례」를 묻는 자리에서 쓴다. */
export function needsMyConfirm(post: ConfirmSource | null | undefined): boolean {
  return confirmStateOf(post) === 'required';
}
